import { isDark } from './isDark';

/**
 * HTML 元素主题类名常量
 */
const HTML_CLASS = {
  light: 'light',
  dark: 'dark',
} as const;

/**
 * 添加亮色或暗色主题类名到文档根元素
 *
 * @param isDarkMode - 是否为暗色模式
 */
function addLightOrDarkClass(isDarkMode: boolean): void {
  if (typeof document === 'undefined') {
    return;
  }

  const { documentElement } = document;

  // 移除当前主题类名
  documentElement.classList.remove(isDarkMode ? HTML_CLASS.light : HTML_CLASS.dark);

  // 添加新的主题类名
  documentElement.classList.add(isDarkMode ? HTML_CLASS.dark : HTML_CLASS.light);
}

/**
 * 初始化主题
 *
 * 根据当前环境检测结果，自动为文档根元素添加相应的主题类名
 *
 * @example
 * ```ts
 * // 在页面加载时初始化主题
 * initTheme();
 *
 * // 文档根元素会自动添加 'light' 或 'dark' 类名
 * // <html class="dark"> 或 <html class="light">
 * ```
 */
export function initTheme(): void {
  if (typeof document === 'undefined') {
    return;
  }

  addLightOrDarkClass(isDark());
}